import { httpClient } from '@shared/api'
import type { UserDTO } from '../model/types'
import { mapUserFromDTO } from './mappers'

export const getUser = async () => {
    const { data: result } = await httpClient.get<UserDTO>('/auth/user')
    return mapUserFromDTO(result)
}
